import { useMemo } from "react";

import Species from "api/types/models/species";
import { FormGroup, Label, Multiselect, Select, SelectOption } from "@mwi/ui";

type SpeciesTabProps = {
  watch: any;
  errors: any;
  control: any;
  species: Species[] | undefined;
};

const SpeciesTab = ({ watch, errors, control, species }: SpeciesTabProps) => {
  const conditionOptions = useMemo(
    () => [
      { id: "does_work_with", name: "Only works with" },
      { id: "doesnt_work_with", name: "Doesn't work with" },
    ],
    [],
  );

  return (
    <div className="flex flex-col gap-y-[18px] mb-20">
      <FormGroup error={errors?.species_condition?.works_with}>
        <Label className="!text-sm">Condition</Label>
        <Select
          control={control}
          placeholder="Select condition"
          name="species_condition.works_with"
        >
          {conditionOptions?.map((condition) => (
            <SelectOption key={condition.id} value={condition.id}>
              {condition.name}
            </SelectOption>
          ))}
        </Select>
      </FormGroup>
      <FormGroup error={errors?.species_condition?.species}>
        <Label className="!text-sm">Species</Label>
        <Multiselect
          control={control}
          placeholder="Select exceptions"
          name="species_condition.species"
          optionsContainerClassName="max-h-[190px]"
          disabled={!watch("species_condition.works_with")}
        >
          {species?.map((s) => (
            <Multiselect.Option key={s.id} value={s.id}>
              {s.name}
            </Multiselect.Option>
          ))}
        </Multiselect>
      </FormGroup>
    </div>
  );
};

export default SpeciesTab;
